import React, { useEffect, useRef, useState } from "react";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import FileInput from "../../../../components/common/ui/Inputs/FileInput";
// import ReactQuill, { Quill } from "react-quill";
import FroalaEditor from "react-froala-wysiwyg";
import { config } from "../../Editor_Config/Froalaconfig";
// CSS (make sure your bundler loads these)
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js"; // All plugins
import Button from "../../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { homePageActions } from "../../../../_store/home.slice";
import SelectInput from "./../../../../components/common/ui/Inputs/SelectInput";

function ContentSection({ Image1, Image2, Image3, errorMessage }) {
  const dispatch = useDispatch();
  const { data } = useSelector((x) => x?.home?.homePageContentResponse);
  const { textEditorTemplate } = useSelector((x) => x?.home);

  const { ColTwoAlginments, ColThreeAlginments, editorColumn } = useSelector(
    (x) => x?.dropDown
  );
  // const Size = Quill.import("attributors/style/size");
  // var Font = Quill.import("formats/font");
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const isFirstRender = useRef(true);
  const homePageData = { ...data };
  // const config = {
  //   // key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  //   placeholderText: "Start typing...",
  //   charCounterCount: true,
  //   toolbarButtons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikeThrough",
  //     "subscript",
  //     "superscript",
  //     "|",
  //     "fontFamily",
  //     "fontSize",
  //     "color",
  //     "inlineStyle",
  //     "paragraphStyle",
  //     "|",
  //     "paragraphFormat",
  //     "align",
  //     "formatOL",
  //     "formatUL",
  //     "outdent",
  //     "indent",
  //     "quote",
  //     "|",
  //     "insertLink",
  //     "insertImage",
  //     "insertVideo",
  //     "insertFile",
  //     "insertTable",
  //     "|",
  //     "emoticons",
  //     "specialCharacters",
  //     "embedly",
  //     "insertHR",
  //     "selectAll",
  //     "clearFormatting",
  //     "|",
  //     "print",
  //     "spellChecker",
  //     "help",
  //     "html",
  //     "|",
  //     "undo",
  //     "redo",
  //   ],
  //   toolbarButtonsXS: null,
  //   toolbarButtonsSM: null,
  //   toolbarButtonsMD: null,
  //   imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  //   // `

  //   // Video upload endpoint (if needed)
  //   videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // File upload endpoint
  //   fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // Extra settings
  //   imageUploadParam: "file", // 👈 match multer field name
  //   fileUploadParam: "file",
  //   videoUploadParam: "file",
  //   events: {
  //     "image.uploaded": function (response) {
  //       const res = JSON.parse(response);
  //       debugger;
  //       if (res.link) {
  //         this.image.insert(
  //           `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
  //           true,
  //           null,
  //           this.image.get(),
  //           response
  //         );
  //         return false; // prevent Froala default insert
  //       }
  //     },
  //   },

  //   // Example: image upload endpoint on your server

  //   // Additional options you might use:
  //   // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  //   // fileUploadURL: '/api/uploads/froala-file',
  //   //
  // };

  // Font.whitelist = [
  //   "arial",
  //   "courier-new",
  //   "georgia",
  //   "tahoma",
  //   "times-new-roman",
  //   "verdana",
  //   "impact",
  //   "wingdings",
  // ];

  // Size.whitelist = [
  //   "8pt",
  //   "10pt",
  //   "12pt",
  //   "14pt",
  //   "18pt",
  //   "24pt",
  //   "36pt",
  //   "48px",
  // ];

  // Quill.register(Size, true);

  // const CustomStyles = `
  // .ql-picker.ql-font .ql-picker-label::before,
  // .ql-picker.ql-font .ql-picker-item::before {
  //     font-family: initial !important;  /* Reset to default font */
  //     content: attr(data-value) !important;  /* Show font name */
  //     text-transform: capitalize !important;  /* Capitalize first letter */
  //     font-size: 16px !important;  /* Increase font size */
  // }

  //   .ql-picker.ql-font { width: 160px !important; }

  //     .ql-picker.ql-size .ql-picker-label::before,
  //     .ql-picker.ql-size .ql-picker-item::before {
  //         content: attr(data-value) !important;
  //         text-transform: none !important;
  //     }
  //         .ql-font-arial { font-family: Arial, sans-serif; }
  //         .ql-font-courier-new { font-family: Courier-New, monospace; }
  //         .ql-font-georgia { font-family: Georgia, serif; }
  //         .ql-font-tahoma { font-family: Tahoma, sans-serif; }
  //         .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
  //         .ql-font-verdana { font-family: Verdana, sans-serif; }
  //         .ql-font-impact { font-family: Impact, sans-serif; }
  //         .ql-font-wingdings { font-family: Wingdings; }

  //          /* Hide only the preview inside the tooltip */
  //         .ql-tooltip .ql-preview {
  //             max-width: 7px !important;
  //             height: 0px !important;
  //             overflow: hidden !important;
  //             white-space: nowrap !important;
  //             display: inline-block !important;
  //             visibility: hidden; /* Hides text but keeps the element */
  //         }
  //         .ql-snow .ql-tooltip::before {
  //             content: none !important; /* Removes the "Visit URL:" text */
  //         }

  //       .ql-snow .ql-tooltip a.ql-action::after {
  //           border-right: 1px solid #ccc;
  //           content: 'Edit';
  //           margin-left: 7px;
  //           padding-right: 8px;
  //       }
  // `;

  // const modules = {
  //   toolbar: [
  //     [{ font: Font.whitelist }],
  //     [{ size: Size.whitelist }],
  //     ["bold", "italic", "underline", "strike", "blockquote"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     [{ script: "sub" }, { script: "super" }],
  //     [{ indent: "-1" }, { indent: "+1" }],
  //     [{ direction: "rtl" }],
  //     [{ color: [] }, { background: [] }],
  //     [{ align: [] }],
  //     ["link"],
  //     ["clean"],
  //   ],
  //   clipboard: {
  //     matchVisual: false,
  //   },
  // };

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  // useEffect(() => {
  //   isFirstRender.current = true;
  // }, []);

  // const handleEditorChanges = (content, name) => {
  //   let cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
  //   if (Object?.keys(homePageData)?.length === 0) return;
  //   if (homePageData[name] === "") {
  //     dispatch(
  //       homePageActions?.updateHomePageResponse({
  //         ...homePageData,
  //         [name]: cleanedContent,
  //       })
  //     );
  //   } else if (homePageData[name] !== "") {
  //     dispatch(
  //       homePageActions?.updateHomePageResponse({
  //         ...homePageData,
  //         [name]: cleanedContent,
  //       })
  //     );
  //   }
  // };

  // useEffect(() => {
  //   const descValue = { ...editorStates };
  //   descValue.contentSectionOneDescription =
  //     homePageData?.contentSectionOneDescription;
  //   descValue.contentSectionTwoDescription =
  //     homePageData?.contentSectionTwoDescription;
  //   descValue.contentSectionThreeDescription =
  //     homePageData?.contentSectionThreeDescription;
  //   setEditorStates(descValue);
  // }, [
  //   homePageData?.contentSectionOneDescription,
  //   homePageData?.contentSectionTwoDescription,
  //   homePageData?.contentSectionThreeDescription,
  // ]);

  // const handleEditorChanges = (content, name) => {
  //   // setActiveEditor(name);

  //   const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
  //   setEditorStates((prev) => ({
  //     ...prev,
  //     [name]: cleanedContent,
  //   }));

  //   // Do not dispatch if unchanged
  //   if (data[name] === cleanedContent || !data) return;

  //   dispatch(
  //     homePageActions?.updateHomePageResponse({
  //       ...data,
  //       [name]: cleanedContent,
  //     })
  //   );
  // };

  // section dropdown
  const [secOneFilter, setSecOneFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });
  const [secTwoFilter, setSecTwoFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });

  const [secThreeFilter, setSecThreeFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });

  const handleEditorChanges = (content, name) => {
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");

    // Do not dispatch if unchanged
    if (homePageData?.[name] === cleanedContent || !homePageData) return;

    const payload = { ...homePageData };
    payload[name] = cleanedContent;

    dispatch(homePageActions?.updateHomePageResponse(payload));
  };

  const handleChange = (e, nameToShow) => {
    const { name, value, type } = e?.target;
    if (type === "file") {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("image", file);
      if (name === "contentSectionOneImage") {
        Image1(file);
      } else if (name === "contentSectionTwoImage") {
        Image2(file);
      } else {
        Image3(file);
      }
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        homePageData[nameToShow] = imageUrl;
      }
      dispatch(homePageActions?.updateHomePageResponse(homePageData));
      return;
    }
    homePageData[name] = value;
    dispatch(homePageActions?.updateHomePageResponse(homePageData));
  };

  const handleEditorFilter = (e, name, page) => {
    const value = e?.value;

    const columnMap = {
      1: { Column: 1, ContentAlignment: "" },
      2: { Column: 2, ContentAlignment: "left-4" },
      3: { Column: 3, ContentAlignment: "left" },
    };

    const setters = {
      1: setSecOneFilter,
      2: setSecTwoFilter,
      3: setSecThreeFilter,
    };

    const setter = setters[page];
    if (!setter) return; // safeguard

    setter((prev) => {
      if (name === "Column") {
        return {
          ...prev,
          ...(columnMap[value] || { Column: null, ContentAlignment: "" }),
        };
      }
      return { ...prev, ContentAlignment: value };
    });
  };

  const handleSearchSection = (e, status, name, column, alignment) => {
    e.preventDefault();
    const payload = { ...homePageData };
    const template = textEditorTemplate?.data;

    if (column === 1) {
      // Filter template for columnSplit = 1
      const htmlValue = template?.filter((d) => d.columnSplit === 1);
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    } else {
      // Filter template for columnSplit = 2
      const htmlValue = template?.filter(
        (d) => d.columnSplit === column && d.fileAlignment === alignment
      );
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    }

    // Dispatch update action
    dispatch(homePageActions.updateHomePageResponse(payload));
  };

  return (
    <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
      <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          {/* Result Based Accountability */}
          Section - 2
        </h1>
        <div className="col-4">
          <SelectInput
            options={editorColumn}
            label="Column"
            name="Column"
            handleChange={(e) => handleEditorFilter(e, "Column", 1)}
            value={secOneFilter?.Column}
          />
        </div>

        <div className="col-4">
          <SelectInput
            options={
              secOneFilter?.Column === 2 ? ColTwoAlginments : ColThreeAlginments
            }
            label="Content Alignment"
            name="ContentAlignment"
            handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 1)}
            value={secOneFilter?.ContentAlignment}
            isDisabled={
              secOneFilter?.Column === 1 || secOneFilter?.Column === undefined
            }
          />
        </div>
        <div className="col-2">
          <Button
            type="submit"
            label="Search"
            status="primary"
            className="mt-4"
            onClick={(e) => {
              handleSearchSection(
                e,
                1,
                "contentSectionOneDescription",
                secOneFilter?.Column,
                secOneFilter?.ContentAlignment
              );
            }}
          />
        </div>
      </div>

      <div className="p-0 row">
        <div className="row mb-4">
          <div className="col-md-12">
            <FroalaEditor
              tag="textarea"
              name="contentSectionOneDescription"
              config={config} // your toolbar, plugins, etc.
              model={homePageData?.contentSectionOneDescription || ""} // ✅ value binding
              onModelChange={(e) => {
                // ✅ onChange equivalent
                handleEditorChanges(e, "contentSectionOneDescription");
              }}
              className={`editor-block ${
                errorMessage?.["contentSectionOneDescription"]
                  ? "input-error"
                  : ""
              }`}
            />

            {errorMessage?.contentSectionOneDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.contentSectionOneDescription}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
        <h1 className="m-0 search-header-color">Section - 3</h1>

        <div className="col-4">
          <SelectInput
            options={editorColumn}
            label="Column"
            name="Column"
            handleChange={(e) => handleEditorFilter(e, "Column", 2)}
            value={secTwoFilter?.Column}
          />
        </div>

        <div className="col-4">
          <SelectInput
            options={
              secTwoFilter?.Column === 2 ? ColTwoAlginments : ColThreeAlginments
            }
            label="Content Alignment"
            name="ContentAlignment"
            handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 2)}
            value={secTwoFilter?.ContentAlignment}
            isDisabled={
              secTwoFilter?.Column === 1 || secTwoFilter?.Column === undefined
            }
          />
        </div>
        <div className="col-2">
          <Button
            type="submit"
            label="Search"
            status="primary"
            className="mt-4"
            onClick={(e) => {
              handleSearchSection(
                e,
                2,
                "contentSectionTwoDescription",
                secTwoFilter?.Column,
                secTwoFilter?.ContentAlignment
              );
            }}
          />
        </div>
      </div>

      <div className="p-0 row">
        <div className="row mb-4">
          <div className="col-md-12">
            <FroalaEditor
              tag="textarea"
              name="contentSectionTwoDescription"
              config={config} // your toolbar, plugins, etc.
              model={homePageData?.contentSectionTwoDescription || ""} // ✅ value binding
              onModelChange={(e) => {
                // ✅ onChange equivalent
                handleEditorChanges(e, "contentSectionTwoDescription");
              }}
              className={`editor-block ${
                errorMessage?.["contentSectionTwoDescription"]
                  ? "input-error"
                  : ""
              }`}
            />

            {errorMessage?.contentSectionTwoDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.contentSectionTwoDescription}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          {/* Result Based Accountability */}
          Section - 4
        </h1>
        <div className="col-4">
          <SelectInput
            options={editorColumn}
            label="Column"
            name="Column"
            handleChange={(e) => handleEditorFilter(e, "Column", 3)}
            value={secThreeFilter?.Column}
          />
        </div>

        <div className="col-4">
          <SelectInput
            options={
              secThreeFilter?.Column === 2
                ? ColTwoAlginments
                : ColThreeAlginments
            }
            label="Content Alignment"
            name="ContentAlignment"
            handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 3)}
            value={secThreeFilter?.ContentAlignment}
            isDisabled={
              secThreeFilter?.Column === 1 ||
              secThreeFilter?.Column === undefined
            }
          />
        </div>
        <div className="col-2">
          <Button
            type="submit"
            label="Search"
            status="primary"
            className="mt-4"
            onClick={(e) => {
              handleSearchSection(
                e,
                3,
                "contentSectionThreeDescription",
                secThreeFilter?.Column,
                secThreeFilter?.ContentAlignment
              );
            }}
          />
        </div>
      </div>
      <div className="p-0 row">
        <div className="row mb-4">
          <div className="col-md-12">
            <FroalaEditor
              tag="textarea"
              name="contentSectionThreeDescription"
              config={config} // your toolbar, plugins, etc.
              model={homePageData?.contentSectionThreeDescription || ""} // ✅ value binding
              onModelChange={(e) => {
                // ✅ onChange equivalent
                handleEditorChanges(e, "contentSectionThreeDescription");
              }}
              className={`editor-block ${
                errorMessage?.["contentSectionThreeDescription"]
                  ? "input-error"
                  : ""
              }`}
            />

            {errorMessage?.contentSectionThreeDescription && (
              <div className="text-danger fw-700 fs-6 mt-1">
                {errorMessage?.contentSectionThreeDescription}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentSection;
